import React, { ErrorInfo } from "react";

import * as Sticker from "ds/Sticker";

import * as S from "./ErrorBoundary.styles";

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error?: Error;
  info?: ErrorInfo;
};

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({
      hasError: true,
      error: error,
      info: info
    });
    const spinner = document.getElementById("pre-loading");
    if (spinner) {
      spinner.remove();
    }
  }

  render() {
    const { error, hasError } = this.state;
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <S.ErrorMessageWrapper className="error-wrapper" priority="critical">
          <Sticker.Icon priority="critical" />
          <Sticker.Text>{error?.message || "error message"}</Sticker.Text>
        </S.ErrorMessageWrapper>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
